import { Box, Typography } from '@mui/material';

/**
 * Replaces the h6-with-icon pattern copy-pasted across the app.
 * Renders an uppercase label (via h6 typography) with an optional leading icon
 * and optional right-side action slot.
 */
export default function SectionHeader({ icon: Icon, children, action, sx = {} }) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2,
                ...sx,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {Icon && <Icon sx={{ fontSize: 16, color: 'text.secondary' }} />}
                <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                    {children}
                </Typography>
            </Box>
            {action}
        </Box>
    );
}
